import React from "react";
import {  Flex, Radio, Text } from "@chakra-ui/react";

interface SelectRadiusProps {
	antecipationYears: string;
	antecipationValue: string;
	description: string;
	isSelected: boolean;
	onSelect(): void;
}

const SelectRadius: React.FC<SelectRadiusProps> = ({
	antecipationYears,
	antecipationValue,
	description,
	isSelected,
	onSelect,
}) => (
	<Flex
		borderWidth="1px"
		borderRadius="16px"
		borderColor={isSelected ? "#660099" : "#DDDDDD"}
		padding={4}
		alignItems="center"
		justifyContent="space-between"
		cursor="pointer"
		onClick={onSelect}
		userSelect="none"
		width="100%"
		maxW={{ base: "279px", lg: "344px" }}
		background="white"
		boxShadow={isSelected ? "0px 2px 6px rgba(0, 0, 0, 0.08)" : "none"}
	>
		<Flex alignItems="flex-start" flexDirection="column">
			<Text fontWeight="400" fontSize={{ sm: "14px", base: "12px" }} color="black">
				{antecipationYears}
			</Text>
			<Text fontSize="24px" fontWeight="600" color="black">
				{antecipationValue}
			</Text>
			<Text color="gray.600" fontSize={{ sm: "14px", base: "12px" }}>
				{description}
			</Text>
		</Flex>

		<Radio
			isChecked={isSelected}
			onChange={onSelect}
			colorScheme="purple"
			pointerEvents="none"
			size="lg"
		/>
	</Flex>
);

export default SelectRadius;
